module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "content content-boxed"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block block-themed"
  }, [_c('div', {
    staticClass: "block-header bg-muted"
  }, [_c('ul', {
    staticClass: "block-options"
  }, [(_vm.flagDisplayBanner === 0) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplayBanner()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-down fa-2x"
  })])]) : _vm._e(), _vm._v(" "), (_vm.flagDisplayBanner) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplayBanner()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-up fa-2x"
  })])]) : _vm._e()]), _vm._v(" "), _c('h2', {
    staticClass: "block-title",
    on: {
      "click": function($event) {
        return _vm.toggleDisplayBanner()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-building fa-1x push-5-r"
  }), _vm._v("  " + _vm._s(_vm.unit.reference_name))])]), _vm._v(" "), (_vm.flagDisplayBanner) ? _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [(_vm.flagDisplayDetail === 0) ? _c('div', {
    staticClass: "block"
  }, [_c('button', {
    staticClass: "btn btn-default align-right",
    attrs: {
      "type": "button",
      "name": "buttonAddPlanItem"
    },
    on: {
      "click": function($event) {
        return _vm.toggleConfigView()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-gear fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.labelButtonConfig[_vm.actualLanguage]))]), _vm._v(" "), _c('h2', {
    staticClass: "block-title push"
  }, [_vm._v("Detail")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 push"
  }, [_c('div', {
    staticClass: "col-xs-12 push"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-9 align-center"
  }, [_c('h5', [_vm._v(_vm._s(_vm.labelButton[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-3"
  }, [_c('label', {
    staticClass: "css-input switch switch-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.flagReadByInvoiceData),
      expression: "flagReadByInvoiceData"
    }],
    attrs: {
      "type": "checkbox",
      "checked": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.flagReadByInvoiceData) ? _vm._i(_vm.flagReadByInvoiceData, null) > -1 : (_vm.flagReadByInvoiceData)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.flagReadByInvoiceData,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.flagReadByInvoiceData = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.flagReadByInvoiceData = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.flagReadByInvoiceData = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span')])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 push"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-4"
  }, [_c('div', {
    staticClass: "input-daterange form-group row"
  }, [_c('div', {
    staticClass: "input-date-time-picker"
  }, [_c('date-picker', {
    staticClass: "el-input__inner form-control",
    attrs: {
      "type": "date",
      "placeholder": "",
      "clear-icon": "",
      "format": "yyyy-MM-dd",
      "value-format": "timestamp"
    },
    model: {
      value: (_vm.visualisationDateStart),
      callback: function($$v) {
        _vm.visualisationDateStart = $$v
      },
      expression: "visualisationDateStart"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-4"
  }, [_c('div', {
    staticClass: "input-daterange form-group row"
  }, [_c('div', {
    staticClass: "input-date-time-picker"
  }, [_c('date-picker', {
    staticClass: "el-input__inner form-control",
    attrs: {
      "type": "date",
      "placeholder": "",
      "clear-icon": "",
      "format": "yyyy-MM-dd",
      "value-format": "timestamp"
    },
    model: {
      value: (_vm.visualisationDateEnd),
      callback: function($$v) {
        _vm.visualisationDateEnd = $$v
      },
      expression: "visualisationDateEnd"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-4"
  }, [_c('button', {
    staticClass: "btn btn-default align-right",
    attrs: {
      "type": "button",
      "name": "buttonAddPlanItem"
    },
    on: {
      "click": function($event) {
        return _vm.readUnitGraphData()
      }
    }
  }, [_vm._v("\r\n                                  " + _vm._s(_vm.labelButtonReadGraph[_vm.actualLanguage]))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 push"
  }, [(_vm.flagGraphDataIsUpdating) ? _c('div', {
    staticClass: "col-xs-12 col-md-12"
  }, [_c('spinner', {
    attrs: {
      "size": "large"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.flagDisplayGraph) ? _c('div', {
    staticClass: "col-xs-12 col-md-12"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-9"
  }, [_c('graph-apex-pies', {
    attrs: {
      "GraphData": _vm.pieChartData
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-3"
  }, [_c('h4', {
    staticClass: "align-center"
  }, [_vm._v(_vm._s(_vm.labelSumCost[_vm.actualLanguage]) + " : " + _vm._s(_vm.sumPeriodCosts) + " $")]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive push"
  }, [_c('table', {
    staticClass: "table table-striped table-vcenter"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "75%"
    }
  }, [_vm._v("Service")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v(_vm._s(_vm.labelCost[_vm.actualLanguage]))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.pieChartData.Data), function(data, index) {
    return _c('tr', [_c('td', {
      staticClass: "font-w600 text-center"
    }, [_vm._v("\r\n                                                    " + _vm._s(_vm.pieChartData.Labels[index]) + "\r\n                                                  ")]), _vm._v(" "), _c('td', {
      staticClass: "font-w600 text-center"
    }, [_vm._v("\r\n                                                    " + _vm._s(data) + " $\r\n                                                  ")])])
  }), 0)])])])]) : _vm._e(), _vm._v(" "), (_vm.flagDisplayGraph) ? _c('div', {
    staticClass: "col-xs-12 col-md-12"
  }, [_c('graph-apex-bars', {
    attrs: {
      "GraphData": _vm.barChartDataUnit1
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.flagDisplayGraph) ? _c('div', {
    staticClass: "col-xs-12 col-md-12"
  }, [_c('graph-apex-bars', {
    attrs: {
      "GraphData": _vm.barChartDataUnit2
    }
  })], 1) : _vm._e()])])]) : _c('div', {
    staticClass: "block"
  }, [_c('button', {
    staticClass: "btn btn-default align-right",
    attrs: {
      "type": "button",
      "name": "buttonAddPlanItem"
    },
    on: {
      "click": function($event) {
        return _vm.toggleConfigView()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.labelButtonConfigClose[_vm.actualLanguage]))]), _vm._v(" "), _c('h1', {
    staticClass: "block-title push"
  }, [_vm._v("Configuration " + _vm._s(_vm.labelUnit[_vm.actualLanguage]) + " ID: " + _vm._s(_vm.unit.unit_id))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-12 push"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [_c('h6', [_vm._v(_vm._s(_vm.labelRefenrenceName[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 push"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.unit.reference_name),
      expression: "unit.reference_name"
    }],
    staticClass: "form-control align-center",
    attrs: {
      "type": "test",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.unit.reference_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.unit, "reference_name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [_c('h6', [_vm._v(_vm._s(_vm.labelUnitTags[_vm.actualLanguage]))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.labelUnitTagsHelp[_vm.actualLanguage]))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.labelUnitTagsHelp2[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6 push"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.unit.unit_tags),
      expression: "unit.unit_tags"
    }],
    staticClass: "form-control",
    attrs: {
      "size": "4",
      "multiple": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.unit, "unit_tags", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "Aucun/None"
    }
  }, [_vm._v("Aucun/None")]), _vm._v(" "), _vm._l((_vm.tagsList), function(type) {
    return _c('option', {
      domProps: {
        "value": type.tagId
      }
    }, [_vm._v(_vm._s(type.tagName))])
  })], 2)])])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-xs align-right",
    attrs: {
      "type": "button",
      "name": "buttonAddPlanItem"
    },
    on: {
      "click": function($event) {
        return _vm.saveUnitModifications()
      }
    }
  }, [(_vm.unitIsSaving) ? _c('spinner', {
    attrs: {
      "size": "small"
    }
  }) : _c('span', [_c('i', {
    staticClass: "fa fa-floppy-o fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.labelButtonSaveModifications[_vm.actualLanguage]))])], 1)]), _vm._v(" "), _c('h1', {
    staticClass: "block-title push"
  }, [_vm._v(_vm._s(_vm.labelSpecificationSection[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-12 push"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-12 push"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [_c('h6', [_vm._v(_vm._s(_vm.labelSpecType[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.unit.spec_type_id),
      expression: "unit.spec_type_id"
    }],
    staticClass: "form-control",
    attrs: {
      "size": "1"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.unit, "spec_type_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.specTypeList), function(type) {
    return _c('option', {
      domProps: {
        "value": type.list_id
      }
    }, [_vm._v(_vm._s(type.description[_vm.actualLanguage]))])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-12 push"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [_c('h6', [_vm._v(_vm._s(_vm.labelSpecArea[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.unit.spec_area_id),
      expression: "unit.spec_area_id"
    }],
    staticClass: "form-control",
    attrs: {
      "size": "1"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.unit, "spec_area_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.specAreaList), function(area) {
    return _c('option', {
      domProps: {
        "value": area.list_id
      }
    }, [_vm._v(_vm._s(area.description[_vm.actualLanguage]))])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-12 push"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [_c('h6', [_vm._v(_vm._s(_vm.labelSpecYearOfConstruction[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.unit.spec_building_construction_year_id),
      expression: "unit.spec_building_construction_year_id"
    }],
    staticClass: "form-control",
    attrs: {
      "size": "1"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.unit, "spec_building_construction_year_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.specYearOfConstructList), function(yearOfConstruct) {
    return _c('option', {
      domProps: {
        "value": yearOfConstruct.list_id
      }
    }, [_vm._v(_vm._s(yearOfConstruct.description[_vm.actualLanguage]))])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-12 push"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [_c('h6', [_vm._v(_vm._s(_vm.labelSpecHeatingIncluded[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [_c('label', {
    staticClass: "css-input switch switch-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.unit.spec_heating_included),
      expression: "unit.spec_heating_included"
    }],
    attrs: {
      "type": "checkbox",
      "checked": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.unit.spec_heating_included) ? _vm._i(_vm.unit.spec_heating_included, null) > -1 : (_vm.unit.spec_heating_included)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.unit.spec_heating_included,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.unit, "spec_heating_included", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.unit, "spec_heating_included", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.unit, "spec_heating_included", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span'), _vm._v(" "), (_vm.unit.spec_heating_included) ? _c('p', [_vm._v(_vm._s(_vm.labelActivated[_vm.actualLanguage]))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-12 push"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [_c('h6', [_vm._v(_vm._s(_vm.labelSpecHotIncludedIncluded[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [_c('label', {
    staticClass: "css-input switch switch-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.unit.spec_hot_water_included),
      expression: "unit.spec_hot_water_included"
    }],
    attrs: {
      "type": "checkbox",
      "checked": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.unit.spec_hot_water_included) ? _vm._i(_vm.unit.spec_hot_water_included, null) > -1 : (_vm.unit.spec_hot_water_included)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.unit.spec_hot_water_included,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.unit, "spec_hot_water_included", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.unit, "spec_hot_water_included", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.unit, "spec_hot_water_included", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span'), _vm._v(" "), (_vm.unit.spec_hot_water_included) ? _c('p', [_vm._v(_vm._s(_vm.labelActivated[_vm.actualLanguage]))]) : _vm._e()])])])]), _vm._v(" "), _c('h1', {
    staticClass: "block-title push"
  }, [_vm._v(_vm._s(_vm.labelUnitServiceAttributions[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-12"
  }, [_c('h5', {
    staticClass: "push"
  }, [_vm._v(_vm._s(_vm.labelAddAttributionSection[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-12 push"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [(_vm.bundleServiceIsLoading == false) ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tempoService),
      expression: "tempoService"
    }],
    staticClass: "form-control",
    attrs: {
      "size": "1"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.tempoService = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.bundleServiceList), function(service) {
    return _c('option', {
      domProps: {
        "value": service
      }
    }, [_vm._v(_vm._s(service.reference_name))])
  }), 0)])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-3"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tempoAttribution),
      expression: "tempoAttribution"
    }],
    staticClass: "form-control align-center",
    attrs: {
      "type": "test",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.tempoAttribution)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.tempoAttribution = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-3"
  }, [_c('button', {
    staticClass: "btn btn-xs align-right",
    attrs: {
      "type": "button",
      "name": "buttonAddPlanItem"
    },
    on: {
      "click": function($event) {
        return _vm.addAttribution()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.tableAttributionsAdd[_vm.actualLanguage]))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-12 push"
  }, [_c('div', {
    staticClass: "table-responsive push"
  }, [_c('table', {
    staticClass: "table table-striped table-vcenter"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "65%"
    }
  }, [_vm._v(_vm._s(_vm.tableAttributionsColumnTitle01[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v(_vm._s(_vm.tableAttributionsColumnTitle02[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v(_vm._s(_vm.tableAttributionsColumnTitle03[_vm.actualLanguage]))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.unit.service_attributions), function(attribution, index) {
    return _c('tr', [_c('td', {
      staticClass: "font-w600"
    }, [_vm._v(_vm._s(attribution.reference_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(attribution.attribution))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('div', {
      staticClass: "btn-group"
    }, [_c('button', {
      staticClass: "btn btn-default",
      attrs: {
        "type": "button",
        "data-toggle": "tooltip",
        "title": "Supprimer/Delete"
      },
      on: {
        "click": function($event) {
          return _vm.deleteAttribution(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])])])])
  }), 0)])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-xs align-right",
    attrs: {
      "type": "button",
      "name": "buttonAddPlanItem"
    },
    on: {
      "click": function($event) {
        return _vm.saveUnitModifications()
      }
    }
  }, [(_vm.unitIsSaving) ? _c('spinner', {
    attrs: {
      "size": "small"
    }
  }) : _c('span', [_c('i', {
    staticClass: "fa fa-floppy-o fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.labelButtonSaveModifications[_vm.actualLanguage]))])], 1)]), _vm._v(" "), _c('h1', {
    staticClass: "block-title push"
  }, [_vm._v(_vm._s(_vm.labelTitleSectionFixCosts[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-12"
  }, [_c('p', {
    staticClass: "push-30"
  }, [_vm._v(_vm._s(_vm.labelFixCostExplanation[_vm.actualLanguage]))]), _vm._v(" "), (_vm.unit.fix_costs.length > 0) ? _c('div', {
    staticClass: "table-responsive push"
  }, [_c('table', {
    staticClass: "table table-striped table-vcenter"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v(_vm._s(_vm.fixCostColumn01[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "18%"
    }
  }, [_vm._v(_vm._s(_vm.fixCostColumn02[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "18%"
    }
  }, [_vm._v(_vm._s(_vm.fixCostColumn03[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.fixCostColumn04[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "14%"
    }
  }, [_vm._v(_vm._s(_vm.fixCostColumn05[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v(_vm._s(_vm.fixCostColumn06[_vm.actualLanguage]))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.unit.fix_costs), function(cost, index) {
    return _c('tr', [_c('td', {
      staticClass: "font-w600"
    }, [_c('div', {
      staticClass: "col-xs-12 col-sm-3"
    }, [_c('label', {
      staticClass: "css-input switch switch-success"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (cost.yearlyFlag),
        expression: "cost.yearlyFlag"
      }],
      attrs: {
        "type": "checkbox",
        "checked": ""
      },
      domProps: {
        "checked": Array.isArray(cost.yearlyFlag) ? _vm._i(cost.yearlyFlag, null) > -1 : (cost.yearlyFlag)
      },
      on: {
        "change": function($event) {
          var $$a = cost.yearlyFlag,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(cost, "yearlyFlag", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(cost, "yearlyFlag", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(cost, "yearlyFlag", $$c)
          }
        }
      }
    }), _vm._v(" "), _c('span')])])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "col-md-12"
    }, [(cost.yearlyFlag == false) ? _c('div', {
      staticClass: "input-daterange form-group row"
    }, [_c('div', {
      staticClass: "input-date-time-picker"
    }, [_c('date-picker', {
      staticClass: "el-input__inner form-control",
      attrs: {
        "type": "date",
        "placeholder": "",
        "clear-icon": "",
        "format": "yy-MM-dd",
        "value-format": "timestamp"
      },
      model: {
        value: (cost.periodStart),
        callback: function($$v) {
          _vm.$set(cost, "periodStart", $$v)
        },
        expression: "cost.periodStart"
      }
    })], 1)]) : _c('div', {
      staticClass: "input-daterange form-group row"
    }, [_c('div', {
      staticClass: "input-date-time-picker"
    }, [_c('date-picker', {
      staticClass: "el-input__inner form-control",
      attrs: {
        "type": "date",
        "placeholder": "",
        "clear-icon": "",
        "format": "MM-dd",
        "value-format": "timestamp"
      },
      model: {
        value: (cost.periodStart),
        callback: function($$v) {
          _vm.$set(cost, "periodStart", $$v)
        },
        expression: "cost.periodStart"
      }
    })], 1)])])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "col-md-12"
    }, [(cost.yearlyFlag == false) ? _c('div', {
      staticClass: "input-daterange form-group row"
    }, [_c('div', {
      staticClass: "input-date-time-picker"
    }, [_c('date-picker', {
      staticClass: "el-input__inner form-control",
      attrs: {
        "type": "date",
        "placeholder": "",
        "clear-icon": "",
        "format": "yy-MM-dd",
        "value-format": "timestamp"
      },
      model: {
        value: (cost.periodEnd),
        callback: function($$v) {
          _vm.$set(cost, "periodEnd", $$v)
        },
        expression: "cost.periodEnd"
      }
    })], 1)]) : _c('div', {
      staticClass: "input-daterange form-group row"
    }, [_c('div', {
      staticClass: "input-date-time-picker"
    }, [_c('date-picker', {
      staticClass: "el-input__inner form-control",
      attrs: {
        "type": "date",
        "placeholder": "",
        "clear-icon": "",
        "format": "MM-dd",
        "value-format": "timestamp"
      },
      model: {
        value: (cost.periodEnd),
        callback: function($$v) {
          _vm.$set(cost, "periodEnd", $$v)
        },
        expression: "cost.periodEnd"
      }
    })], 1)])])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "col-xs-12 col-sm-12 push"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (cost.description),
        expression: "cost.description"
      }],
      staticClass: "form-control align-center",
      attrs: {
        "type": "test",
        "placeholder": ""
      },
      domProps: {
        "value": (cost.description)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(cost, "description", $event.target.value)
        }
      }
    })])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "col-xs-12 col-sm-12 push"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (cost.cost),
        expression: "cost.cost"
      }],
      staticClass: "form-control align-center",
      attrs: {
        "type": "test",
        "placeholder": ""
      },
      domProps: {
        "value": (cost.cost)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(cost, "cost", $event.target.value)
        }
      }
    })])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('div', {
      staticClass: "btn-group"
    }, [_c('button', {
      staticClass: "btn btn-default",
      attrs: {
        "type": "button",
        "data-toggle": "tooltip",
        "title": "Supprimer/Delete"
      },
      on: {
        "click": function($event) {
          return _vm.deleteFixCost(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])])])])
  }), 0)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-12 push"
  }, [_c('button', {
    staticClass: "btn btn-xs align-right push",
    attrs: {
      "type": "button",
      "name": "buttonAddPlanItem"
    },
    on: {
      "click": function($event) {
        return _vm.addFixCostLine()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.labelButtonAddFixCost[_vm.actualLanguage]))])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-xs align-right",
    attrs: {
      "type": "button",
      "name": "buttonAddPlanItem"
    },
    on: {
      "click": function($event) {
        return _vm.saveUnitModifications()
      }
    }
  }, [(_vm.unitIsSaving) ? _c('spinner', {
    attrs: {
      "size": "small"
    }
  }) : _c('span', [_c('i', {
    staticClass: "fa fa-floppy-o fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.labelButtonSaveModifications[_vm.actualLanguage]))])], 1)]), _vm._v(" "), _c('h1', {
    staticClass: "block-title push"
  }, [_vm._v("Options")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-12"
  }, _vm._l((_vm.unit.options), function(category, index) {
    return _c('div', {
      staticClass: "col-xs-12 col-md-12 push"
    }, [_c('h5', {}, [_c('u', [_vm._v(_vm._s(category.categoryTitle[_vm.actualLanguage]))])]), _vm._v(" "), _c('p', {
      staticClass: "push-30"
    }, [_vm._v(_vm._s(category.categoryDescription[_vm.actualLanguage]))]), _vm._v(" "), _vm._l((category.options), function(Option, index2) {
      return _c('div', {
        staticClass: "col-xs-12 col-md-12 push"
      }, [(Option.valueType == 'bool') ? _c('div', {
        staticClass: "col-xs-12 col-md-12"
      }, [_c('div', {
        staticClass: "col-xs-12 col-sm-9"
      }, [_c('h5', [_vm._v(_vm._s(Option.optionLabel[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
        staticClass: "col-xs-12 col-sm-3"
      }, [_c('label', {
        staticClass: "css-input switch switch-success"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (Option.value),
          expression: "Option.value"
        }],
        attrs: {
          "type": "checkbox",
          "checked": ""
        },
        domProps: {
          "checked": Array.isArray(Option.value) ? _vm._i(Option.value, null) > -1 : (Option.value)
        },
        on: {
          "change": function($event) {
            var $$a = Option.value,
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.$set(Option, "value", $$a.concat([$$v])))
              } else {
                $$i > -1 && (_vm.$set(Option, "value", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
              }
            } else {
              _vm.$set(Option, "value", $$c)
            }
          }
        }
      }), _vm._v(" "), _c('span'), _vm._v(" "), (Option.value) ? _c('p', [_vm._v(_vm._s(_vm.labelActivated[_vm.actualLanguage]))]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (Option.valueType == 'stringNumber') ? _c('div', {
        staticClass: "col-xs-12 col-md-12 push"
      }, [_c('div', {
        staticClass: "col-xs-12 col-sm-9"
      }, [_c('h6', [_vm._v(_vm._s(Option.optionLabel[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
        staticClass: "col-xs-12 col-sm-3"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (Option.value),
          expression: "Option.value"
        }],
        staticClass: "form-control align-center",
        attrs: {
          "type": "test",
          "placeholder": ""
        },
        domProps: {
          "value": (Option.value)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(Option, "value", $event.target.value)
          }
        }
      })])]) : _vm._e(), _vm._v(" "), (Option.valueType == 'compilationPeriodicity') ? _c('div', {
        staticClass: "col-xs-12 col-md-12 push"
      }, [_c('div', {
        staticClass: "col-xs-12 col-sm-9"
      }, [_c('h6', [_vm._v(_vm._s(Option.optionLabel[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
        staticClass: "col-xs-12 col-sm-3"
      }, [_c('select', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (Option.value),
          expression: "Option.value"
        }],
        staticClass: "form-control",
        attrs: {
          "size": "1"
        },
        on: {
          "change": function($event) {
            var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
              return o.selected
            }).map(function(o) {
              var val = "_value" in o ? o._value : o.value;
              return val
            });
            _vm.$set(Option, "value", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
          }
        }
      }, _vm._l((_vm.periodicityOptions), function(option) {
        return _c('option', {
          domProps: {
            "value": option.value
          }
        }, [_vm._v(_vm._s(option.displayText[_vm.actualLanguage]))])
      }), 0)])]) : _vm._e(), _vm._v(" "), (Option.valueType == 'dayInMonthString') ? _c('div', {
        staticClass: "col-xs-12 col-md-12 push"
      }, [_c('div', {
        staticClass: "col-xs-12 col-sm-9"
      }, [_c('h6', [_vm._v(_vm._s(Option.optionLabel[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
        staticClass: "col-xs-12 col-sm-3"
      }, [_c('select', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (Option.value),
          expression: "Option.value"
        }],
        staticClass: "form-control",
        attrs: {
          "size": "1"
        },
        on: {
          "change": function($event) {
            var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
              return o.selected
            }).map(function(o) {
              var val = "_value" in o ? o._value : o.value;
              return val
            });
            _vm.$set(Option, "value", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
          }
        }
      }, _vm._l((_vm.listDaysInMonth), function(day) {
        return _c('option', {
          domProps: {
            "value": day
          }
        }, [_vm._v(_vm._s(day))])
      }), 0)])]) : _vm._e(), _vm._v(" "), (Option.valueType == 'compareLevelMessageList') ? _c('div', {
        staticClass: "col-xs-12 col-md-12 push"
      }, [_c('div', {
        staticClass: "col-xs-12 col-sm-9"
      }, [_c('h6', [_vm._v(_vm._s(Option.optionLabel[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
        staticClass: "col-xs-12 col-sm-3"
      }, [_c('select', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (Option.value),
          expression: "Option.value"
        }],
        staticClass: "form-control",
        attrs: {
          "size": "1"
        },
        on: {
          "change": function($event) {
            var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
              return o.selected
            }).map(function(o) {
              var val = "_value" in o ? o._value : o.value;
              return val
            });
            _vm.$set(Option, "value", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
          }
        }
      }, _vm._l((_vm.messageList), function(list) {
        return _c('option', {
          domProps: {
            "value": list.complement_id
          }
        }, [_vm._v(_vm._s(list.referenceName))])
      }), 0)])]) : _vm._e(), _vm._v(" "), (Option.valueType == 'listString') ? _c('div', {
        staticClass: "col-xs-12 col-md-12"
      }, [_vm._v("\r\n                                  " + _vm._s(Option) + "\r\n                                ")]) : _vm._e()])
    })], 2)
  }), 0), _vm._v(" "), _c('button', {
    staticClass: "btn btn-xs align-right",
    attrs: {
      "type": "button",
      "name": "buttonAddPlanItem"
    },
    on: {
      "click": function($event) {
        return _vm.saveUnitModifications()
      }
    }
  }, [(_vm.unitIsSaving) ? _c('spinner', {
    attrs: {
      "size": "small"
    }
  }) : _c('span', [_c('i', {
    staticClass: "fa fa-floppy-o fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.labelButtonSaveModifications[_vm.actualLanguage]))])], 1)])])])]) : _vm._e()])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-6"
  }, [_c('h6', [_vm._v("Attribution(%)")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b45d0390","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/cost_splitting/UnitDisplay.vue
// module id = 1577
// module chunks = 4